<template>
  <main class="welfare-page">
    <section class="welfare-hero">
      <img class="welfare-slide welfare-slide-one" src="@/assets/images/welfare/banner1.jpg" alt="美菜 SOS 助农" />
      <img class="welfare-slide welfare-slide-two" src="@/assets/images/welfare/banner2.jpg" alt="最美菜公益助农" />
      <div class="welfare-dots" aria-hidden="true"><span></span><span></span></div>
    </section>

    <section class="inner-section welfare-projects-section">
      <div class="inner-heading"><h2>让农民离幸福更进一步</h2></div>
      <div class="welfare-projects">
        <router-link v-for="(item, index) in projects" :key="item.title" :to="item.link" class="welfare-project">
          <div class="welfare-project-media"><img :src="item.image" :alt="item.title" /><span>0{{ index + 1 }}</span></div>
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </router-link>
      </div>
    </section>

    <section class="inner-section welfare-media-section">
      <div class="inner-heading"><h2>媒体报道</h2></div>
      <div class="welfare-media-grid">
        <a v-for="item in media" :key="item.title" :href="item.link" target="_blank">
          <img :src="item.image" :alt="item.title" />
          <div><h3>{{ item.title }}</h3><p>来源：{{ item.source }}</p></div>
        </a>
      </div>
    </section>

    <section class="inner-section other-welfare-section">
      <div class="inner-heading"><h2>其他公益项目</h2></div>
      <div class="other-projects-grid">
        <article v-for="(item, index) in otherProjects" :key="item.title" :class="index === 0 ? 'other-project-wide' : 'other-project-compact'">
          <img :src="item.image" :alt="item.title" />
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </article>
      </div>
    </section>

    <section class="inner-section related-reports-section">
      <div class="inner-heading"><h2>相关报道</h2></div>
      <div class="related-reports-grid">
        <router-link v-for="(item, index) in reports" :key="item.title" :to="'/news/report' + (index + 1)">
          <img :src="item.image" :alt="item.title" /><h3>{{ item.title }}</h3>
        </router-link>
      </div>
    </section>

    <section class="welfare-cta">
      <div class="welfare-cta-inner"><h2>最美菜公益基金 助力贫困地区农产品上行</h2><router-link to="/commonweal">我有滞销菜</router-link></div>
    </section>
    <HomeFooter />
  </main>
</template>

<script>
import HomeFooter from "../../home/components/footer";

export default {
  name: "WelfarePage",
  components: { HomeFooter },
  data() {
    return {
      projects: [
        { title: "“疫”路护航，瑞安老农别哭泣！", text: "战疫当下，封道封路，温州瑞安陶山镇大批农产品待销，当地菜农面临巨大损失，美菜得知后，在封道封路、困难重重的特殊时期，紧急前往温州瑞安，全力帮助瑞安菜农渡过难关。", image: require("@/assets/images/welfare/plan-1.png"), link: "/news/media1" },
        { title: "美菜“三军联动”挽救南通市搬经镇千亩良田", text: "南通市搬经镇受疫情影响，已经成熟的数万斤蔬菜依然在地里无法售出。苏州、无锡、上海美菜联合行动，把美菜人的爱心带到当地。", image: require("@/assets/images/welfare/plan-2.png"), link: "/news/media2" },
        { title: "不误春耕，重燃希望——成都美菜 SOS 爱心采购彭州滞销蔬菜 5.5 吨", text: "成都彭州地区受疫情影响，出现蔬菜大面积滞销。美菜立即成立项目组前往帮扶农户，采购爱心蔬菜 5.5 吨。", image: require("@/assets/images/welfare/plan-3.png"), link: "/news/media3" }
      ],
      media: [
        { title: "美菜 SOS 爱心助农抗疫 瑞安数万斤滞销菜有救了", source: "中国网", image: require("@/assets/images/welfare/media-news2.png"), link: "http://news.china.com.cn/txt/2020-02/14/content_75705131.htm" }
      ],
      otherProjects: [
        { title: "天镇“抢谷大战”，美菜保底收购小米上线商城", text: "山西省天镇县马家皂乡属于国家级贫困县，当地盛产小米，却因缺少销路一直不被市场认可。美菜开展深度产业扶持计划，并签下“订单生产”合同，全力帮扶当地农民。", image: require("@/assets/images/welfare/other2.png") },
        { title: "美菜招募全国闲置店面及小区物业 全力助推抗疫期间的民生保障工作", text: "面对突发疫情，餐厅需要发展多种经营。美菜菜店招募全国闲置店面及小区物业，帮助门店引流增收，在保障民生的同时减少损失。", image: require("@/assets/images/welfare/other3.png") }
      ],
      reports: [
        { title: "凌晨4点，疫情下武汉美菜人的勇敢", image: require("@/assets/images/welfare/report1-1.jpg") },
        { title: "武汉蔬菜便民快车来了！美菜联手公交集团为市民保供", image: require("@/assets/images/welfare/report2-2.jpg") },
        { title: "同休戚，共进退！美菜全力支援湖南防疫一线食材保障", image: require("@/assets/images/welfare/report3-1.jpg") }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.welfare-page { color: #242a31; font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif; font-size: 16px; line-height: 1.5; }
.welfare-hero { position: relative; height: 27.083vw; min-height: 300px; max-height: 520px; margin-top: 0; overflow: hidden; }
.welfare-slide { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.welfare-slide-one { animation: welfare-slide-one 10s infinite; }
.welfare-slide-two { opacity: 0; animation: welfare-slide-two 10s infinite; }
.welfare-dots { position: absolute; z-index: 2; bottom: 14px; left: 50%; display: flex; gap: 7px; transform: translateX(-50%); }
.welfare-dots span { width: 28px; height: 3px; background: rgba(255,255,255,.55); }.welfare-dots span:first-child { background:#fff; }
.inner-section { box-sizing: border-box; padding: 68px clamp(28px, 7vw, 112px); }
.inner-heading { margin-bottom: 38px; }.inner-heading h2 { margin: 0; font-size: 28px; font-weight: 600; letter-spacing: 0; }
.welfare-projects-section { padding-bottom:110px; background: #fff; }.welfare-projects { display: grid; gap: 22px; grid-template-columns: repeat(3, 1fr); }
.welfare-project { overflow: hidden; color: inherit; text-decoration: none; }.welfare-project-media { position: relative; aspect-ratio: 4 / 3; overflow: hidden; }.welfare-project-media img { width:100%;height:100%;object-fit:cover;transition:transform .4s ease; }.welfare-project:hover img { transform:scale(1.035); }.welfare-project-media span { display:none; }.welfare-project > div:last-child { padding:22px 0; }.welfare-project h3 { margin:0 0 14px;font-size:17px;line-height:1.5; }.welfare-project p { margin:0;color:#727b87;font-size:13px;line-height:1.8; }
.welfare-media-section { padding-top:110px;padding-bottom:110px;background:transparent; }.welfare-media-grid { display:grid;gap:22px;grid-template-columns:repeat(2,1fr); }.welfare-media-grid a { display:grid;min-height:190px;grid-template-columns:48% 52%;color:inherit;background:#fff;text-decoration:none; }.welfare-media-grid img { width:100%;height:100%;object-fit:cover; }.welfare-media-grid a > div { padding:18px; }.welfare-media-grid h3 { margin:0 0 14px;font-size:15px;line-height:1.5; }.welfare-media-grid p { margin:0;color:#68ad25;font-size:12px; }
.other-welfare-section { padding-top:110px;padding-bottom:110px;background:transparent; }.other-welfare-section .inner-heading { position:relative;text-align:center; }.other-welfare-section .inner-heading::before,.other-welfare-section .inner-heading::after { position:absolute;top:50%;width:38%;height:1px;background:#bbb;content:""; }.other-welfare-section .inner-heading::before { left:0; }.other-welfare-section .inner-heading::after { right:0; }.other-welfare-section h2 { position:relative;z-index:1;display:inline-block;padding:0 26px;background:#fff;line-height:1.08; }.other-projects-grid article { display:grid;grid-template-columns:240px 1fr;min-height:280px;margin-bottom:50px;background:#f3f6f1; }.other-projects-grid img { width:240px;height:280px;object-fit:cover; }.other-projects-grid article > div { padding:28px 40px; }.other-projects-grid h3 { margin:0 0 14px;font-size:23px;line-height:1.45; }.other-projects-grid p { margin:0;color:#727b87;font-size:13px;line-height:1.8; }
.related-reports-section { padding-top:55px;padding-bottom:68px;background:#092b19;color:#fff; }.related-reports-grid { display:grid;gap:22px;grid-template-columns:repeat(3,1fr); }.related-reports-grid a { overflow:hidden;color:#fff;background:rgba(255,255,255,.08);text-decoration:none; }.related-reports-grid img { width:100%;aspect-ratio:16/9;object-fit:cover; }.related-reports-grid h3 { margin:0;padding:24px;font-size:16px;line-height:1.6; }
.welfare-cta { position:fixed;z-index:28;right:0;bottom:0;left:0;height:60px;background:#f4f4f4;color:#c0c0c0; }.welfare-cta-inner { display:flex;max-width:1050px;height:60px;margin:0 auto;align-items:center; }.welfare-cta h2 { margin:0;font-size:26px;font-weight:400;letter-spacing:0; }.welfare-cta a { display:flex;width:280px;align-self:stretch;margin-left:auto;align-items:center;justify-content:center;background:#4bc17c;color:#fff;font-size:20px;text-decoration:none;transition:background .2s ease; }.welfare-cta a:hover { background:#3eae6c; }.welfare-page /deep/ .site-footer { padding-bottom:90px; }
@keyframes welfare-slide-one { 0%,45%{opacity:1} 50%,95%{opacity:0} 100%{opacity:1} } @keyframes welfare-slide-two { 0%,45%{opacity:0} 50%,95%{opacity:1} 100%{opacity:0} }

@media (max-width: 1100px) {
  .welfare-cta-inner { margin-right: 28px; margin-left: 28px; }
}

@media (max-width: 1080px) {
  .welfare-projects { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 900px) {
  .welfare-cta h2 { font-size: 20px; white-space: nowrap; }
  .welfare-cta a { width: 220px; font-size: 17px; }
}

@media (max-width: 720px) {
  .welfare-hero { height: 300px; min-height: 300px; }
  .inner-section { padding: 74px 20px; }
  .inner-heading { margin-bottom: 36px; }
  .welfare-projects,
  .welfare-media-grid,
  .related-reports-grid { grid-template-columns: 1fr; }
  .welfare-media-grid a { grid-template-columns: 1fr; }
  .welfare-media-grid img { height: auto; aspect-ratio: 16 / 9; }
  .other-welfare-section .inner-heading::before,
  .other-welfare-section .inner-heading::after { width: 20%; }
  .other-projects-grid article,
  .other-project-compact { min-height: 0; max-width: none; grid-template-columns: 1fr; }
  .other-projects-grid img,
  .other-project-compact img { width: 100%; height: auto; }
  .welfare-cta { height: 56px; min-height: 56px; }
  .welfare-cta-inner { height: 56px; margin-right: 18px; margin-left: 18px; }
  .welfare-cta h2 { max-width: calc(100% - 132px); font-size: 14px; line-height: 1.35; white-space: normal; }
  .welfare-cta a { width: 120px; font-size: 14px; }
  .welfare-page /deep/ .site-footer { padding-bottom: 82px; }
}
</style>
